import React, { useEffect, useState } from "react";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import axios from "axios";
import { CSVLink } from "react-csv";
import { baseurl } from "../../baseurl";
import { FiEdit2, FiTrash2, FiPlusCircle } from "react-icons/fi";
import Swal from "sweetalert2"; 
import "flatpickr/dist/themes/material_blue.css";
import { useNavigate } from "react-router-dom";



function AllMedicine() {
  const [medicines, setMedicines] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [actionType, setActionType] = useState("in");
  const [quantity, setQuantity] = useState("");
  const [showModal, setShowModal] = useState(false);
const navigate = useNavigate();

  // 🟢 Fetch Medicines
  const fetchMedicines = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseurl}getMedicines`);
      setMedicines(res.data || []);
    } catch (err) {
      console.error("Error fetching medicines:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMedicines();
  }, []);

  // 🔍 Search Filter
  const filtered = medicines.filter(
    (m) =>
      m.name?.toLowerCase().includes(search.toLowerCase()) ||
      m.category?.toLowerCase().includes(search.toLowerCase()) ||
      m.supplier?.toLowerCase().includes(search.toLowerCase())
  );

  // 🗑 Delete
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete Medicine?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (confirm.isConfirmed) {
      try {
        await axios.delete(`${baseurl}deleteMedicine/${id}`);
        Swal.fire("Deleted!", "Medicine removed successfully.", "success");
        fetchMedicines();
      } catch (err) {
        Swal.fire("Error", "Failed to delete medicine.", "error");
      }
    }
  };

  // ✏️ Edit (navigate or show modal)
const handleEdit = (m) => {
  navigate(`/edit-medicine/${m.id}`);
};

  // 📦 Open Stock Modal
  const openStockModal = (m) => {
    setSelectedMedicine(m);
    setActionType("in");
    setQuantity("");
    setShowModal(true);
  };

  // 📦 Handle Stock Update
  const handleStockUpdate = async () => {
    if (!quantity || quantity < 0) {
      Swal.fire("Error", "Enter a valid quantity.", "error");
      return;
    }

    let finalStock = selectedMedicine.stock;
    if (actionType === "in") finalStock = +selectedMedicine.stock + +quantity;
    else if (actionType === "out")
      finalStock = Math.max(0, selectedMedicine.stock - quantity);
    else if (actionType === "adjust") finalStock = +quantity;

    try {
      await axios.post(`${baseurl}updateMedicineStock/${selectedMedicine.id}`, {
        actionType,
        quantity,
        finalStock,
      });

      Swal.fire({
        icon: "success",
        title: "Stock Updated",
        text: `Action: ${actionType.toUpperCase()} | New Stock: ${finalStock}`,
        timer: 1800,
        showConfirmButton: false,
      });

      setShowModal(false);
      fetchMedicines();
    } catch (err) {
      Swal.fire("Error", "Failed to update stock.", "error");
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />

      <main className="main-wrapper">
        <div className="main-content">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="breadcrumb-title mb-0">💊 All Medicines</h4>
            <div>
              <input
                type="text"
                className="form-control d-inline-block me-2"
                style={{ width: 250 }}
                placeholder="Search medicine, supplier..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <CSVLink
                data={filtered}
                filename={"medicines.csv"}
                className="btn btn-primary"
              >
                Export CSV
              </CSVLink>
            </div>
          </div>

          {/* Table */}
          <div className="card shadow-sm border-0">
  <div className="card-body table-responsive">
    {loading ? (
      <table className="table table-striped align-middle text-center">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Batch</th>
            <th>Category</th>
            <th>Stock</th>
            <th>Unit</th>
            <th>Selling / Cost ₹</th>
            <th>GST %</th>
            <th>Expiry</th>
            <th>Rack</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 6 }).map((_, i) => (
            <tr key={i}>
              {Array.from({ length: 12 }).map((__, j) => (
                <td key={j}>
                  <div className="skeleton skeleton-line" style={{ width: `${60 + j * 3}px` }}></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <table className="table table-striped align-middle text-center">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Batch</th>
            <th>Category</th>
            <th>Stock</th>
            <th>Unit</th>
            <th>Selling / Cost ₹</th>
            <th>GST %</th>
            <th>Expiry</th>
            <th>Rack</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filtered.length > 0 ? (
            filtered.map((m, i) => (
              <tr key={m.id}>
                <td>{i + 1}</td>
                <td className="fw-semibold text-start">{m.name}</td>
                <td>{m.batch_number}</td>
                <td>{m.category}</td>
                <td>{m.stock}</td>
                <td>{m.unit}</td>
                <td>
                  ₹{m.selling_price} /{" "}
                  <small className="text-muted">₹{m.cost_price}</small>
                </td>
                <td>{m.gst}%</td>
                <td>
  {new Date(m.expiry_date) < new Date() ? (
    <span className="badge bg-danger">
      {new Date(m.expiry_date).toLocaleDateString("en-GB")}
    </span>
  ) : (
    <span className="badge bg-success">
      {new Date(m.expiry_date).toLocaleDateString("en-GB")}
    </span>
  )}
</td>

                <td>{m.rack_number}</td>
                <td>
                  <span
                    className={`badge px-2 py-1 ${
                      m.status === "active" ? "bg-success" : "bg-secondary"
                    }`}
                  >
                    {m.status}
                  </span>
                </td>
                <td>
                  <div className="d-flex justify-content-center gap-2">
                    <button
                      className="btn btn-sm btn-outline-success"
                      title="Update Stock"
                      onClick={() => openStockModal(m)}
                    >
                      <FiPlusCircle size={16} />
                    </button>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      title="Edit Medicine"
                      onClick={() => handleEdit(m)}
                    >
                      <FiEdit2 size={16} />
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      title="Delete Medicine"
                      onClick={() => handleDelete(m.id)}
                    >
                      <FiTrash2 size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="12" className="text-center py-3">
                No medicines found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    )}
  </div>
</div>


        </div>
      </main>

      {/* 🧩 Stock Update Modal */}
      {showModal && selectedMedicine && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header  text-white">
                <h5 className="modal-title">
                  📦 Update Stock - {selectedMedicine.name}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Action Type</label>
                  <select
                    className="form-select"
                    value={actionType}
                    onChange={(e) => setActionType(e.target.value)}
                  >
                    <option value="in">Stock In (+)</option>
                    <option value="out">Stock Out (-)</option>
                    <option value="adjust">Adjust (Set Exact)</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Quantity</label>
                  <input
                    type="number"
                    min="0"
                    className="form-control"
                    placeholder="Enter quantity"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                  />
                </div>

                <div className="alert alert-light border">
                  <strong>Current Stock:</strong> {selectedMedicine.stock}
                  <br />
                  <strong>
                    New Stock (Preview):
                    <span className="text-primary ms-2">
                      {actionType === "in"
                        ? +selectedMedicine.stock + +(quantity || 0)
                        : actionType === "out"
                        ? Math.max(0, selectedMedicine.stock - (quantity || 0))
                        : quantity || selectedMedicine.stock}
                    </span>
                  </strong>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-success"
                  onClick={handleStockUpdate}
                >
                  Update Stock
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AllMedicine;
